import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchStates, createState, fetchState, modifyState, deleteStateApi, changeStatus } from '../../api/stateApi';

export const getStates = createAsyncThunk('state/getStates', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchStates(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addState = createAsyncThunk('state/addState', async (payload, { rejectWithValue }) => {
  try {
    const response = await createState(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getStateDetails = createAsyncThunk('state/getStateDetails', async (stateId, { rejectWithValue }) => {
  try {
    const response = await fetchState(stateId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateState = createAsyncThunk('state/updateState', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyState(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteState = createAsyncThunk('state/deleteState', async (stateId, { rejectWithValue }) => {
  try {
    const response = await deleteStateApi(stateId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('state/changeActiveStatus', async (stateId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(stateId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const stateSlice = createSlice({
  name: 'state',
  initialState: {
    states: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.states = action.payload;
      })
      .addCase(getStates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default stateSlice.reducer;
